module.exports = __webpack_public_path__ + "static/media/Dashboard.2a6f842e.svg";